import { useState } from 'react'

import Button from 'src/ui/atoms/Button'
import useIsWalletConnected from 'src/hooks/useIsWalletConnected'
import useProjectApi, { IProject } from '../../useProjectApi'

const CheckValidateProject = ({ project, reFetch }: { project: IProject; reFetch: any }) => {
  const { checkValidateProject } = useProjectApi()
  const { isConnected } = useIsWalletConnected({ chain: project.data.chain })

  const [checking, setChecking] = useState<boolean>(false)

  const handleCheckValidation = async () => {
    setChecking(true)
    try {
      await checkValidateProject(project)
      reFetch()
    } catch (error) {
      console.error('Check error', error)
    } finally {
      setChecking(false)
    }
  }

  return (
    <>
      <Button
        name="Check validation"
        size="M"
        disabled={!isConnected}
        loading={checking}
        onClick={handleCheckValidation}
      />
    </>
  )
}

export default CheckValidateProject
